var React = require('react');

function OverviewIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h9.167v11.917H0zm11.917 0h9.167v7.333h-9.167zM0 14.667h9.167V22H0zm11.917-4.584h9.167V22h-9.167z"}));
}

OverviewIconInline.defaultProps = {"width":"22","height":"22","fill":"#606060","fillRule":"evenodd","xmlnsV":"https://vecta.io/nano"};

module.exports = OverviewIconInline;

OverviewIconInline.default = OverviewIconInline;
